<template>
  <div>
    <!-- 联系我们 -->
    <section class="advertise-section section" v-if="$store.state.screenWidth > 768">
      <div class="img-wrap">
        <img src="@/assets/images/header/advertise.png" alt="" />
      </div>
      <div class="content w-page2">
        <h4 v-html="contactTxt"></h4>
        <div class="contact-btn click-enter" @click="jumpRoute('/contact')">
          {{ $route.path.indexOf('/problem') >= 0 ? $t('message.tools.msg5') : $t('message.contactBtn') }}
        </div>
      </div>
    </section>

    <section class="advertise-section section" :class="currentLang == 'en' ? 'en' : ''" v-else>
      <div class="img-wrap">
        <img src="@/assets/images/header/advertise-mobile.png" alt="" />
      </div>
      <div class="content w-page2">
        <h4 v-html="contactMobileTxt"></h4>
        <div class="contact-btn click-enter" @click="jumpRoute('/contact')">
          {{ $route.path.indexOf('/problem') >= 0 ? $t('message.tools.msg5') : $t('message.contactBtn') }}
        </div>
      </div>
    </section>

    <footer class="footer w-page2 section2">
      <div class="footer-top d-flex">
        <div class="logo cussor-pointer">
          <img src="@/assets/images/login/login-logo.png" alt="" />
          <div class="copyright">
            © 2025 XPIRORY PTE. LTD. All rights reserved
          </div>
          <div v-if="host == '.com'">
            <!-- <div class="copyright-link">
              <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2025181297号</a>
            </div> -->
            <div class="copyright-link">
              {{ $t('message.header.phone') }}: +65 31251162
            </div>
          </div>
          <div v-else>
            <div class="copyright-link">
              <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2025181297号-1</a>
            </div>
            <div class="copyright-link">
              全国统一服务热线: +86 4000502885
            </div>
          </div>
        </div>
        <div class="footer-links">
          <div class="footer-column" v-if="false">
            <!-- AI建站 -->
            <h3 class="footer-title">{{ $t('message.header.navList[0].children[0].name') }}</h3>
          </div>
          <div class="footer-column">
            <!-- 获客工具 -->
            <h3 class="footer-title" @click="jumpRoute('/developTools')">{{ $t('message.index.text9') }}</h3>
            <ul class="footer-menu">
              <li>
                <a class="cursor-pointer" @click.prevent="toDevelopTools({
                  index: 0,
                  path: '/marketAnalytics',
                })">{{ $t('message.header.navList[0].children[1].children[0].name') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toDevelopTools({
                  index: 1,
                  path: '/globalCustomer',
                })">{{ $t('message.header.navList[0].children[1].children[1].name') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toDevelopTools({
                  index: 2,
                  path: '/customerInsights',
                })">{{ $t('message.header.navList[0].children[1].children[2].name') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toDevelopTools({
                  index: 5,
                  path: '/smartEmail',
                })">{{ $t('message.index.text2') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toDevelopTools({
                  index: 5,
                  path: '/smartEmail',
                })">{{ $t('message.index.text3') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toDevelopTools({
                  index: 3,
                  path: '/smartPoster',
                })">{{ $t('message.header.navList[0].children[1].children[3].name') }}</a>
              </li>
              
            </ul>
          </div>
          <div class="footer-column">
            <!-- 商机转化工具 -->
            <h3 class="footer-title" @click="jumpRoute('/tools?activeIndex2=0')">{{ $t('message.index.text10') }}</h3>
            <ul class="footer-menu">
              <li>
                <!-- 产品宣传页制作 -->
                <a class="cursor-pointer" @click.prevent="toDevelopTools({
                  path: '',
                })">{{ $t('message.index.text4') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toDevelopTools({
                  path: '/strategyCoach',
                })">{{ $t('message.header.navList[0].children[1].children[6].name') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toSupportTools({
                  path: '/painPoints',
                })">{{ $t('message.header.navList[0].children[2].children[0].children[0].name') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toSupportTools({
                  index: 4,
                })">{{ $t('message.header.navList[0].children[2].children[0].children[1].name') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toSupportTools({
                  path: '/solutionGenerationPlatform',
                })">{{ $t('message.header.navList[0].children[2].children[0].children[2].name') }}</a>
              </li>
              <li>
                <a class="cursor-pointer" @click.prevent="toSupportTools({
                  index: 5,
                })">{{ $t('message.header.navList[0].children[2].children[0].children[3].name') }}</a>
              </li>
            </ul>
          </div>
          <div class="footer-column">
            <!-- 语音同传/策略沟通助手 -->
            <h3 class="footer-title" @click="jumpRoute('/speechTranslator')">{{ $t('message.index.text5') }}</h3>
          </div>
          <div class="footer-column">
            <!-- 关于我们 -->
            <h3 class="footer-title" @click="jumpRoute('/about')">{{ $t('message.header.navList[1].name') }}</h3>

            <!-- 联系我们 -->
            <h3 class="footer-title" @click="jumpRoute('/contact')">{{ $t('message.header.navList[2].name') }}</h3>

            <!-- 用户指南 -->
            <h3 class="footer-title" @click="jumpRoute('/docs')">{{ $t('message.header.docs') }}</h3>

            <!-- FAQ -->
            <h3 class="footer-title" @click="jumpRoute('/faq')">{{ 'FAQ' }}</h3>
          </div>
        </div>
      </div>
      <div class="footer-bottom d-flex align-center justify-content-between">
        <div class="social-links d-flex align-center">
          <a href="https://www.facebook.com/people/Xpirory/61576890436067/" target="_blank" class="social-link"><img src="@/assets/images/header/social-icons/Facebook.png" alt="" /></a>
          <a href="https://x.com/xpirory66721" target="_blank" class="social-link"><img src="@/assets/images/header/social-icons/Twitter.png" alt="" /></a>
          <!-- <a href="" class="social-link"><img src="@/assets/images/header/social-icons/Instagram.png" alt="" /></a> -->
          <a href="https://www.youtube.com/@Xpirory" target="_blank" class="social-link"><img src="@/assets/images/header/social-icons/Youtube.png" alt="" /></a>
          <a class="social-link special">
            <!-- <img class="hover-img" src="@/assets/images/footer/whats-hover.png" alt=""> -->
            <img src="@/assets/images/footer/whats-app.png" alt="" />
          </a>
          <template v-if="host == '.cn'">
            <!-- .cn 抖音 -->
            <a class="social-link special">
              <img class="hover-img" src="@/assets/images/footer/douyin-hover.png" alt="">
              <img src="@/assets/images/footer/douyin.png" alt="" />
            </a>
            <!-- .cn 微信 -->
            <a class="social-link special">
              <img class="hover-img" src="@/assets/images/footer/wechat-hover.png" alt="">
              <img src="@/assets/images/footer/wechat.png" alt="" />
            </a>
          </template>
          <!-- <a href="#" class="social-link"><img src="@/assets/images/header/social-icons/Instagram2.png" alt="" /></a> -->
        </div>
        <div class="policyAndTerms">
          <a class="cursor-pointer" @click.prevent="jumpRoute('/privacyPolicy')">{{ $t('message.privacyPolicy') }}</a>
          <a class="cursor-pointer" @click.prevent="jumpRoute('/useTerms')">{{ $t('message.terms') }}</a>
        </div>
        <div class="login-link d-flex align-items-center cursor-pointer" @click="goLogin">
          <img src="@/assets/images/header/login-link-icon.png" alt="" class="mr-1" />
          {{ $t('message.header.loginBtn') }}
        </div>
      </div>
      <div class="dial-phone" @click="dialNumber" v-if="$store.state.screenWidth < 768 && host != '.com'">
        <i class="el-icon-phone-outline"></i> 拨打电话
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'FooterComponent',
  props: {
    currentLang: {
      type: String,
      default: 'cn',
    },
    // contact us
    contactTxt: {
      type: String,
      default: '联系我们，开启您的数智化加速之旅！',
    },
    contactMobileTxt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      host: '',
      width: '',
    };
  },
  mounted() {
    this.width = document.documentElement.clientWidth;
    this.host = location.host.substring(location.host.lastIndexOf('.'));
  },
  methods: {
    dialNumber() {
      window.location.href = `tel:+8615026760702`;
    },
    // 联系我们
    contactUs() {
      // window.open('https://www.lingyao.com/');
    },
    jumpRoute(route) {
      if(route == '/docs') {
        this.goLogin();
        return;
      }
      this.$router.push(route);
      window.scrollTo(0, 0);
      localStorage.setItem('firstNavIndex', -1);
    },
    toDevelopTools(data) {
      if(!data.path) return;
      this.$router.push(data.path);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    toSupportTools(data) {
      if(data.path) {
        this.$router.push(data.path);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        this.$router.push(`/tools?activeIndex2=${data.index}`);
      }
    },
    // 登录
    goLogin() {
      window.location.href = `https://user.xpirory.cn/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`;
      // this.$router.push('/contact');
      localStorage.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
.advertise-section {
  position: relative;

  .img-wrap {
    width: 100%;

    img {
      width: 100%;
    }
  }

  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      font-size: 28px;
      color: #fff;
      margin: 0;
      font-weight: 400;
      letter-spacing: 3px;
    }

    .contact-btn {
      font-size: 20px;
      color: #fff;
      padding: 10px 50px;
      border-radius: 4px;
      border: 1px solid #fff;
      text-align: center;
      cursor: pointer;
      letter-spacing: 2px;
    }

    .contact-btn:hover {
      border-color: transparent;
    }
  }
}

.footer {
  .footer-top {
    gap: 100px;
    margin-bottom: 40px;

    .logo img {
      height: 24px;
    }

    .copyright {
      font-size: 14px;
      color: #fffefe;
      margin-top: 20px;
      font-family: 'Arial';
    }

    .footer-links {
      display: flex;
      flex-wrap: wrap;
      gap: 90px;
    }

    .footer-title {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 32px;
      transition: color 0.3s;
      cursor: pointer;
      &:hover {
        color: #1867ff;
      }
    }

    .footer-menu {
      list-style: none;
      color: #999;
      padding-left: 10px;
    }

    .footer-menu li {
      margin-bottom: 12px;
      position: relative;

      &::before {
        content: '';
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background-color: #999;
        position: absolute;
        top: 50%;
        left: -10px;
        transform: translate(0, -50%);
      }
    }

    .footer-menu a {
      color: #999;
      text-decoration: none;
      font-size: 14px;
      transition: color 0.3s;
    }

    .footer-menu a:hover {
      color: #1867ff;
    }
  }

  .footer-bottom {
    padding-top: 32px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    gap: 90px;

    .social-links {
      width: 252px;
      gap: 32px;
    }

    .social-link {
      cursor: pointer;
      color: #999;
      font-size: 18px;
      transition: color 0.3s;
      &.special {
        position: relative;
        &:hover .hover-img {
          display: block;
        }
      }
      .hover-img {
        display: none;
        position: absolute;
        top: -110px;
        width: 100px!important;
        height: 100px;
        transform: translateX(-35%);
      }
    }

    .policyAndTerms {
      margin-left: -330px;
      a {
        color: #999;
        text-decoration: none;
        font-size: 14px;
        transition: color 0.3s;
        &:first-child {
          margin-right: 146px;
        }
        &:hover {
          color: #1867ff;
        }
      }
    }

    .social-link:hover {
      color: #1867ff;
    }

    .social-link:nth-child(1),
    .social-link:nth-child(2) {
      img {
        width: 27px;
      }
    }
    .social-link:nth-child(3) {
      img {
        width: 24px;
      }
    }
    .social-link:nth-child(4) {
      img {
        width: 26px;
      }
    }
    .social-link:nth-child(5),
    .social-link:nth-child(6) {
      img {
        width: 30px;
      }
    }

    .login-link {
      img {
        width: 12px;
        font-size: 14px;
      }
    }
  }
}

.copyright-link {
  margin-top: 10px;
  a {
    text-decoration: none;
    cursor: pointer;
    color: #fffefe;
    font-size: 14px;
    transition: color 0.3s;
    &:hover {
      color: #1867ff;
    }
  }
}

.en-container {
  .advertise-section {
    .content {
      .contact-btn {
        padding: 10px 20px;
        width: 230px;
      }
    }
  }
  .footer {
    .footer-top {
      .footer-links {
        gap: 30px;
      }
    }
    .policyAndTerms {
      margin-left: -250px;
      a {
        &:first-child {
          margin-right: 170px;
        }
      }
    }
  }
}
</style>
